// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import loginRoutes from './components/loginRoutes';
import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies';
import Vuetify from 'vuetify';
import { store } from '../store';
import router from './router/loginRoutesIndex';

require('../common/assets/scss/login.scss');
require('../node_modules/mdi/css/materialdesignicons.css');

Vue.config.debug = true
Vue.config.productionTip = false

Vue.use(Vuetify);
Vue.use(VueResource);
Vue.use(VueCookies);

Vue.prototype.$eventHub = new Vue();

// VueCookies.set('tenantID','public');
// console.log(VueCookies.get('tenantID'));

var login4IQ = new Vue({
    el: '#loginRoutes',
    template: '<loginRoutes/>',
    vuetify: new Vuetify(),
    store,
    components: {
        'LoginRoutes': loginRoutes
    },
    router
});

// var login4IQ = new Vue({
//     el: '#app-login',
//     template: '<Login/>',
//     components: {
//         'Login': Login
//     }
// });